import { render, staticRenderFns } from "./AdmitDetailsFields.vue?vue&type=template&id=25da838b"
import script from "./AdmitDetailsFields.vue?vue&type=script&lang=ts"
export * from "./AdmitDetailsFields.vue?vue&type=script&lang=ts"
import style0 from "./AdmitDetailsFields.vue?vue&type=style&index=0&id=25da838b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports